"use client";
import { initFirebase } from "lib/firebase";
import logOut from "lib/log-out";
import cookies from "js-cookie";
import includes from "lodash/includes";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

interface Props {
  children: React.ReactNode;
}

const loginRedirectionWhitelist = [
  "/login",
  "/a/login",
  "/s/[slug]/onboarding",
];

initFirebase();

const AuthenticationHandler = ({ children }: Props): React.ReactNode => {
  const { push, replace } = useRouter();
  const pathname = usePathname();

  const redirectToLogin = () => {
    if (!loginRedirectionWhitelist.includes(pathname)) {
      logOut();

      push("/login");
    }
  };

  useEffect(() => {
    const token = cookies.get("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    if (!token || !refreshToken) {
      redirectToLogin();
      return;
    }

    if (includes(["/login", "/_error", "/a/login"], pathname)) {
      return;
    }

    if (pathname === "/") replace("/client");
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return children;
};

export default AuthenticationHandler;
